import { TimeframeFilter } from 'app/modules/reporting/components/TimeframeExport';

import { endOfDay, isSameDay, startOfDay } from 'date-fns';

import { FilterReportDetail } from './type';

export const emptyFilterReportDetail: FilterReportDetail = {
  action: {},
  from_expriry_date: null,
  to_expriry_date: null,
};

export const INITIAL_FILTER_VALUE: TimeframeFilter = {
  fromDate: startOfDay(new Date()),
  toDate: endOfDay(new Date()),
};

export const RANGES = (filter: TimeframeFilter) => [
  {
    key: 'selection',
    startDate: filter.fromDate,
    endDate: filter.toDate,
  },
];

const PRESET_RANGES = [
  {
    label: 'Today',
    range: () => ({
      startDate: startOfDay(new Date()),
      endDate: endOfDay(new Date()),
    }),
  },
  {
    label: 'Yesterday',
    range: () => {
      const date = new Date();
      date.setDate(date.getDate() - 1);
      return {
        startDate: startOfDay(date),
        endDate: endOfDay(date),
      };
    },
  },
  {
    label: 'This Week',
    range: () => {
      const now = new Date();
      const start = new Date(now);
      start.setDate(now.getDate() - now.getDay());
      return {
        startDate: startOfDay(start),
        endDate: endOfDay(now),
      };
    },
  },
  {
    label: 'Last 7 Days',
    range: () => {
      const now = new Date();
      const start = new Date();
      start.setDate(now.getDate() - 6);
      return {
        startDate: startOfDay(start),
        endDate: endOfDay(now),
      };
    },
  },
  {
    label: 'Last 30 Days',
    range: () => {
      const now = new Date();
      const start = new Date();
      start.setDate(now.getDate() - 29);
      return {
        startDate: startOfDay(start),
        endDate: endOfDay(now),
      };
    },
  },
  {
    label: 'This Month',
    range: () => {
      const now = new Date();
      const start = new Date(now.getFullYear(), now.getMonth(), 1);
      return {
        startDate: startOfDay(start),
        endDate: endOfDay(now),
      };
    },
  },
  {
    label: 'Last Month',
    range: () => {
      const now = new Date();
      const start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      const end = new Date(now.getFullYear(), now.getMonth(), 0);
      return {
        startDate: startOfDay(start),
        endDate: endOfDay(end),
      };
    },
  },
  {
    label: 'Last 3 Months',
    range: () => {
      const now = new Date();
      const start = new Date(now.getFullYear(), now.getMonth() - 3, 1);
      const end = new Date(now.getFullYear(), now.getMonth(), 0);
      return {
        startDate: startOfDay(start),
        endDate: endOfDay(end),
      };
    },
  },
];

export const CUSTOM_STATIC_RANGES: any = [
  ...PRESET_RANGES,
  {
    label: 'Custom',
    range: () => ({
      startDate: startOfDay(new Date()),
      endDate: endOfDay(new Date()),
    }),
    isSelected: (range: any) =>
      !PRESET_RANGES.some((preset) => {
        const p = preset.range();
        return isSameDay(range.startDate, p.startDate) && isSameDay(range.endDate, p.endDate);
      }),
  },
];
